<script>
import {headerState} from "@/stores/headerStore.js";
import ConnectionStatus from "@/components/ConnectionStatus.vue";
import MenuSidebar from "@/components/layout/MenuSidebar.vue";
import LocalePicker from "@/components/locale/LocalePicker.vue";

export default {
    components: {LocalePicker, MenuSidebar, ConnectionStatus},
    computed: {
        header() {
            const currentTitle = headerState.title || this.$t(this.$route.meta.header) || '';

            if (!currentTitle) return '';

            return '<span class="header-underline">' + currentTitle.substring(0, 2) + '</span>' + currentTitle.substring(2);
        },
        subtitle() {
            return headerState.subtitle
        },
        routerKey() {
            return headerState.routerKey
        }
    }
}
</script>

<template>
    <loader :loading="!$auth.isReady" full-page></loader>
    <div v-if="$auth.isReady">
        <menu-sidebar v-if="$auth.isLoggedIn()"></menu-sidebar>

        <section v-bind:class="{main: $auth.isLoggedIn() || $route.meta.public}">
            <div v-bind:class="{'container': $auth.isLoggedIn() || $route.meta.public}">
                <div class="block header" v-if="$route.meta.header">
                    <h1 class="title is-size-4" v-html="header"></h1>
                    <h2 v-if="subtitle">{{ subtitle  }}</h2>
                </div>
                <router-view :key="routerKey"/>
            </div>
        </section>
    </div>
    <div class="light-switch-wrapper" v-if="!$auth.isLoggedIn()">
        <div class="menu-tools">
            <light-switch/>
            <LocalePicker/>
        </div>
        <ConnectionStatus />
    </div>
</template>
<style scoped lang="scss">
@use "bulma/sass/utilities/mixins";

.container {
    padding-inline: 1rem;
    padding-block: 3rem;

    @include mixins.desktop {
        padding-inline: 3rem;
    }
}

.menu-tools {
    gap: 12px;
}

.locale-picker {
    position: absolute;
    top: 1rem;
    left: 1rem;
}
</style>
